// components/landingPage/AIInsights.jsx
import React from 'react';

const AIInsights = () => {
  return (
    <section className="py-20 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          AI-Powered Insights
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12">
          Smart recommendations to maximize your revenue and minimize waste
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-emerald-50 to-green-100 rounded-2xl p-6 border border-emerald-200">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white font-bold text-sm">!</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Expiry Alert</h3>
                <p className="text-gray-700 mb-4">
                  Your Sweet Potato Vines and seaweed extract are expiring in 16 days. 
                  Consider updating prices or creating promotions.
                </p>
                <button className="bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-4 rounded-lg transition-colors">
                  Check Listings
                </button>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-cyan-100 rounded-2xl p-6 border border-blue-200">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white font-bold text-sm">↑</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Optimization Opportunity</h3>
                <p className="text-gray-700 mb-4">
                  Boost visibility for Sweet Potato Vines by updating descriptions 
                  or adjusting prices for better market positioning.
                </p>
                <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors">
                  Optimize Listings
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIInsights;